import type { HelpStep } from '../../types/help';

interface HelpStepListProps {
  steps: HelpStep[];
}

export default function HelpStepList({ steps }: HelpStepListProps) {
  return (
    <ol className="space-y-6">
      {steps.map((step) => (
        <li key={step.number} className="flex gap-4">
          {/* Step number */}
          <div
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-semibold"
            style={{
              backgroundColor: 'var(--oro-surface-alt)',
              color: 'var(--oro-gold)',
              border: '1px solid var(--oro-border)',
            }}
          >
            {step.number}
          </div>

          {/* Step content */}
          <div className="min-w-0 flex-1 pt-1">
            <h4
              className="font-medium"
              style={{ color: 'var(--text-primary)' }}
            >
              {step.title}
            </h4>
            <p
              className="mt-1 text-sm leading-relaxed"
              style={{ color: 'var(--text-secondary)' }}
            >
              {step.content}
            </p>

            {/* Step image (if any) */}
            {step.image && (
              <div className="mt-3">
                <img
                  src={step.image}
                  alt={step.imageAlt || `Step ${step.number}: ${step.title}`}
                  className="max-w-full rounded-lg border"
                  style={{ borderColor: 'var(--oro-border)' }}
                />
              </div>
            )}
          </div>
        </li>
      ))}
    </ol>
  );
}
